export default __webpack_public_path__ + "static/media/appstore.7e9d0758.svg";